import React from "react";
import styled from "styled-components";
import { P } from "../Texts";

const CheckBoxStyle = styled.input`
  background: transparent;

  &,
  &:after,
  &:before {
    border: 1px solid #cecae1;
    border-radius: 5px;
  }

  :checked + label {
    font-weight: 600;
  }
`;

export const CheckBox = React.forwardRef(
  (
    {
      className,
      id,
      name,
      label,
      labelColor = "#1E202A",
      labelClassName,
      labelFontSize,
      defaultChecked,
    },
    ref,
  ) => {
    return (
      <div className="flex items-center">
        <CheckBoxStyle
          type="checkbox"
          ref={ref}
          name={name}
          id={id}
          className={className}
          defaultChecked={defaultChecked}
        />
        {label && (
          <label htmlFor={id}>
            <P
              fontSize={labelFontSize}
              smallSize={labelFontSize}
              color={labelColor}
              className={`ml-4 ${labelClassName}`}
            >
              {label}
            </P>
          </label>
        )}
      </div>
    );
  },
);
